/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
}

.qds-tag {
  align-items: center;
  border-radius: var(--qds-feedback-rounded-border-radius);
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  max-width: inherit;
  min-width: inherit;
  width: inherit;
}

.qds-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qds-sr-only {
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

.qds-icon {
  flex-shrink: 0;
}

[data-status='error'] {
  color: var(--qds-theme-feedback-message-critical);
}

[data-status='success'] {
  color: var(--qds-theme-feedback-message-success);
}

[data-status='warning'] {
  color: var(--qds-theme-feedback-message-important);
}

[data-status='info'] {
  color: var(--qds-theme-feedback-message-informational);
}

[data-status='neutral'] {
  color: var(--qds-theme-feedback-message-neutral);
}

[data-importance='subdued'] .qds-text {
  color: var(--qds-theme-text-standard);
}

[data-importance='standard'] {
  &[data-status='error'] {
    background-color: var(--qds-theme-feedback-message-critical-dimmed);
  }

  &[data-status='success'] {
    background-color: var(--qds-theme-feedback-message-success-dimmed);
  }

  &[data-status='warning'] {
    background-color: var(--qds-theme-feedback-message-important-dimmed);
  }

  &[data-status='info'] {
    background-color: var(--qds-theme-feedback-message-informational-dimmed);
  }

  &[data-status='neutral'] {
    background-color: var(--qds-theme-feedback-message-neutral-dimmed);
  }
}

[data-importance='emphasized'] {
  &[data-status='error'] {
    background-color: var(--qds-theme-feedback-message-critical);
    color: var(--qds-theme-feedback-message-critical-contrast);
  }

  &[data-status='success'] {
    background-color: var(--qds-theme-feedback-message-success);
    color: var(--qds-theme-feedback-message-success-contrast);
  }

  &[data-status='warning'] {
    background-color: var(--qds-theme-feedback-message-important);
    color: var(--qds-theme-feedback-message-important-contrast);
  }

  &[data-status='info'] {
    background-color: var(--qds-theme-feedback-message-informational);
    color: var(--qds-theme-feedback-message-informational-contrast);
  }

  &[data-status='neutral'] {
    background-color: var(--qds-theme-feedback-message-neutral);
    color: var(--qds-theme-feedback-message-neutral-contrast);
  }
}

[data-size='small'] {
  &.qds-tag {
    font: var(--qds-feedback-tag-small-text);
    gap: var(--qds-feedback-tag-small-gap-internal);
    height: var(--qds-feedback-tag-small-height);
  }

  &.qds-padding {
    padding-inline: var(--qds-feedback-tag-small-padding-horizontal);
  }

  &.qds-icon {
    width: var(--qds-feedback-tag-small-icon-size);
    height: var(--qds-feedback-tag-small-icon-size);
  }
}

[data-size='standard'] {
  &.qds-tag {
    font: var(--qds-feedback-tag-standard-text);
    gap: var(--qds-feedback-tag-standard-gap-internal);
    height: var(--qds-feedback-tag-standard-height);
  }

  &.qds-padding {
    padding-inline: var(--qds-feedback-tag-standard-padding-horizontal);
  }

  &.qds-icon {
    width: var(--qds-feedback-tag-standard-icon-size);
    height: var(--qds-feedback-tag-standard-icon-size);
  }
}

[data-size='large'] {
  &.qds-tag {
    font: var(--qds-feedback-tag-large-text);
    gap: var(--qds-feedback-tag-large-gap-internal);
    height: var(--qds-feedback-tag-large-height);
  }

  &.qds-padding {
    padding-inline: var(--qds-feedback-tag-large-padding-horizontal);
  }

  &.qds-icon {
    width: var(--qds-feedback-tag-large-icon-size);
    height: var(--qds-feedback-tag-large-icon-size);
  }
}
